// @file Whiteboard card template preview component
import { cn } from '@@/bits/tailwind'
import { createBridgeToReactState } from '@@/bits/vue_react_bridge'
import { useWhiteboardCardTemplatesStore } from '@@/pinia/whiteboard_card_templates'
import { useWhiteboardPanelsStore } from '@@/pinia/whiteboard_panels'
import { computed } from 'vue'

const whiteboardPanelsStore = useWhiteboardPanelsStore()
const whiteboardCardTemplatesStore = useWhiteboardCardTemplatesStore()

const useCardTemplatePreviewUrl = createBridgeToReactState(
  computed<string>(() => whiteboardCardTemplatesStore.previewCardTemplateUrl ?? ''),
)

const useShouldFadeOut = createBridgeToReactState(
  computed<boolean>(
    () =>
      !whiteboardCardTemplatesStore.isApplyingCardTemplate &&
      !whiteboardPanelsStore.xCardTemplatesPanel &&
      whiteboardCardTemplatesStore.isShowingCardTemplatePreview,
  ),
)

const WhiteboardCardTemplatePreview = (): React.JSX.Element => {
  const [url] = useCardTemplatePreviewUrl()
  const [shouldFadeOut] = useShouldFadeOut()
  return (
    <div className="w-full h-full bg-grey-50 pointer-events-none">
      <div
        data-testid="whiteboardCardTemplatePreview"
        className={cn(
          'w-full h-full bg-no-repeat bg-contain bg-center transition-opacity duration-200',
          shouldFadeOut ? 'opacity-0' : 'opacity-100',
        )}
        style={{
          backgroundImage: `url(${url})`,
        }}
      ></div>
    </div>
  )
}

export default WhiteboardCardTemplatePreview
